import classNames from 'classnames';
import React from 'react';

export enum Color {
  White = 'white',
  BlueLight = 'tuftsBlueLight'
}

interface Props {
  color?: Color;
  className?: string;
}

const Line: React.FC<Props> = ({ color, className }) => {
  const styles = require('./Line.module.scss');
  const lineClassName = classNames(styles.line, color && styles[`line-${color}`], className);

  return <div className={lineClassName} />;
};

export default Line;
